import {Component, Input, Output, EventEmitter, signal, OnInit} from '@angular/core';

import {CoreModule} from "src/app/_core/core.module";
import { AppService } from 'src/app/app.service';
import {MatSliderModule} from '@angular/material/slider';
import {MatChipsModule} from '@angular/material/chips';
import {FormsModule} from '@angular/forms';
import {isUndefined} from "lodash";
import {TranslateChatPipe} from "../../chat.service";

@Component({
  selector: 'app-chat-search-question',
  standalone: true,
	imports: [
		CoreModule,
		FormsModule,
		MatSliderModule,
		MatChipsModule,
		TranslateChatPipe
	],
  templateUrl: './chat-search-question.component.html',
  styleUrl: './chat-search-question.component.scss'
})
export class ChatSearchQuestionComponent implements OnInit {
	@Input() public question: any;
	@Output() public apply: EventEmitter<any> = new EventEmitter();


	loaded = signal(false);

	constructor(
		public appService: AppService,
	) {

	}

	_apply() {
		this.apply.emit(this.question);
	}

	ngOnInit(): void {
		let data = this.question;
		if (!data.processed) {
			data.processed = true;
			data.fields.forEach(field => {
				if (isUndefined(field.default) ) {
					switch (field.type) {
						case 'chips': field.value = []; break;
					}
				} else {
					field.value = field.default;
				}

			});
		}
		this.loaded.set(true);
	}

	generateRange(field): number[] {
		const n = field.max - field.min;
		return Array(n).fill(0);
	}

	toggleChip(field, value) {
		const index = field.value.indexOf(value);
		if (index == -1) {
			if (field.selectionType === 'single') {
				field.value = [value];
			} else {
				field.value.push(value);
			}
		}else {
			field.value.splice(index, 1);
		}
	}

	fieldIncrement(field, op) {
		if (isNaN(field.value)) field.value = field.value === field.min;
		let newVal = field.value + op;
		if (newVal > field.max) newVal = field.max;
		else if (newVal < field.min) newVal = field.min;
		field.value = newVal;
	}

}
